module.exports = __webpack_public_path__ + "media/images/flags/1x1/cyp-b7edc25e303fe629bc97e7ca662bd4f2.svg";